// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const updateFailureModes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getClaimDefaultState().failureModes, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_NORMAL_FAILURE_MODE_COLLECTION]: updateFailureModes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/failure-modes.js